var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { loading } from 'elements/Loading';
import { Form } from 'components';
import { FieldType } from 'elements';
import { rules } from 'helpers/Validation';
import { T as Traduce } from '../../../helpers/i18n';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fields = [
            {
                name: 'name',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 5
            },
            {
                name: 'code',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 5
            },
            {
                name: 'tin',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 5
            },
            {
                name: 'description',
                type: FieldType.TextArea,
                rules: rules()
                    .string(),
                size: 10
            },
            {
                name: 'image',
                type: FieldType.Image,
                accept: 'image/jpeg',
                footer: 'Imagen en los tickets, formato jpg\n recomendado 200x200px',
                size: 10,
            },
            {
                name: 'emails',
                type: FieldType.Text,
                tooltipId: 'emails',
                tooltip: Traduce('emailsToSend'),
                rules: rules()
                    .arrayEmailsComma(),
                size: 10
            },
        ];
        return _this;
    }
    default_1.prototype.render = function () {
        var businessUnit = this.props.businessUnit;
        var businessUnits = this.props.store.businessUnits;
        // console.log('BusinessUnitsForm - render - businessUnit: ', businessUnit)
        return (React.createElement("div", null,
            React.createElement(Form
            /*delete={this.props.match.params.id}*/
            , { 
                /*delete={this.props.match.params.id}*/
                loading: ['post@businessunits/', 'put@businessunits/', 'delete@businessunits/'], fields: this.fields, values: businessUnit, store: businessUnits })));
    };
    default_1 = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id
                ? props.store.businessUnits.read(props.match.params.id).then(function (businessUnit) { return ({ businessUnit: businessUnit }); })
                : undefined
        ]; })
    ], default_1);
    return default_1;
}(Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/BusinessUnits/container/BusinessUnitsForm.tsx
// module id = 1254
// module chunks = 0